import React, { } from "react";
import { useGlobalState } from "./GlobalStateProvider";
import "./Clear.css";

const Clear: React.FC = () => {
  const { currentStep } = useGlobalState();

  const norm =
    <>
      <section id="bg-area">
        <img src={`${process.env.PUBLIC_URL}/img/still_80.webp`}></img>
      </section>
      <section id="game-clear">
        <div className="clear-flex">
          <img id="title-ed" src={`${process.env.PUBLIC_URL}/img/title.webp`} />
          <div>
            <h2 style={{ borderBottom: "1px solid", padding: "0.5rem", fontSize: "140%" }}>脱出成功です</h2>
            <p>この本があなたに何をしようとするかわかりませんから、</p>
            <p>どこか少し離れた場所に置いておいてください。</p>
            <p>彼女をかまってくれそうなあなたの友人なんかに</p>
            <p>渡してしまうといいかもしれません。</p>
            <p>それでは、改めて脱出成功おめでとうございます。</p>
          </div>
        </div>
        <div>
          <p>この本を、どこか人目のつくところに置いてくる。</p>
          <a href="https://twitter.com/intent/tweet?hashtags=%E3%83%90%E3%83%89%E3%82%A2%E3%82%BD&related=nei_ion&text=%E2%96%AE%20Gothic%20%E8%84%B1%E5%87%BA%E6%88%90%E5%8A%9F%0A%E4%B8%80%E5%86%8A%E3%81%AE%E6%9C%AC%E3%81%8C%E3%80%81%E3%81%82%E3%81%AA%E3%81%9F%E3%81%AB%E6%8B%BE%E3%82%8F%E3%82%8C%E3%82%8B%E3%81%AE%E3%82%92%E5%BE%85%E3%81%A3%E3%81%A6%E3%81%84%E3%81%BE%E3%81%99%E3%80%82%0A&url=https://bad-assort.com/play-now/gothic-neue/&openExternalBrowser=1" target="_blank" className="post-x">ポスト(X)</a>
        </div>
        <div style={{ fontSize: "80%" }}>
          <p className="delay">もしも彼女のことを哀れに思う気持ちがあるのであれば、もう一度考え直してみてください。</p>
          <p className="delay">まだ何かできることが残っているかもしれません。</p>
          <p className="delay">置いてきた本を取りに戻るなら、どうかこれだけは気を付けて――名前を渡せば、奪われる。</p>
          <p className="delay">だから、あなたの名前は、教えない。</p>
          <p className="delay">あなたがそこまで彼女のことを気にかけてくれるなら、の話ですが……。</p>
          <p><a href="https://bad-assort.com/artworks/gothic-overture/?language=faechatter" target="_blank"> - 彼女の過去を知る - </a></p>
        </div>
      </section>
    </>;

  const helv = <>
    <img className="abs-bg-img" src={`${process.env.PUBLIC_URL}/img/still_93.webp`} />
    <section id="true-clear">
      <div className="clear-flex">
        <img id="title-ed" src={`${process.env.PUBLIC_URL}/img/title.webp`} />
        <div>
          <h2 style={{ borderBottom: "1px solid", padding: "0.5rem", fontSize: "160%" }}>完全クリア</h2>
          <p>あなたはGothicの全ての謎を解き明かしました。</p>
          <p>完全クリアおめでとうございます。</p>
        </div>
      </div>
      <div>
        <p>完全クリア報告はこちらから</p>
        <a href="https://twitter.com/intent/tweet?hashtags=%E3%83%90%E3%83%89%E3%82%A2%E3%82%BD&related=nei_ion&text=%E2%96%AE%20Gothic:Neue%20%E5%AE%8C%E5%85%A8%E3%82%AF%E3%83%AA%E3%82%A2%0AWeb%E8%AC%8E%20Gothic%20%E3%81%AE%E5%85%A8%E3%81%A6%E3%81%AE%E8%AC%8E%E3%82%92%E8%A7%A3%E3%81%8D%E6%98%8E%E3%81%8B%E3%81%97%E3%81%BE%E3%81%97%E3%81%9F%EF%BC%81%0A&url=https://bad-assort.com/play-now/gothic-neue/&openExternalBrowser=1" target="_blank" className="post-x">ポスト(X)</a>
      </div>
      <div style={{ fontSize: "80%" }}>
        <p>EDイラスト：るあ様(@yrhruaa)</p>
        <p>BGM：京極みやび様(@miyabi_ky)</p>
        <p>Gothic by Bad Assort - Thanks for take care of me.</p>
      </div>
    </section></>;

  const dcay = <>
    <section id="bg-area">
      <img className="dark-bg-img" src={`${process.env.PUBLIC_URL}/img/still_102.webp`} />
    </section>
    <section id="true-clear">
      <div className="clear-flex">
        <img id="title-ed" src={`${process.env.PUBLIC_URL}/img/title.webp`} style={{ filter: "none" }} />
        <div>
          <h2 style={{ borderBottom: "1px solid", padding: "0.5rem", fontSize: "160%" }}>おまけコンテンツ　クリア</h2>
        </div>
      </div>
      <div>
        <a href="https://twitter.com/intent/tweet?hashtags=%E3%83%90%E3%83%89%E3%82%A2%E3%82%BD&related=nei_ion&text=%E2%96%AE%20Gothic%3ANeue%20%E3%81%8A%E3%81%BE%E3%81%91%E3%82%B3%E3%83%B3%E3%83%86%E3%83%B3%E3%83%84%20%E3%82%AF%E3%83%AA%E3%82%A2&url=https://bad-assort.com/play-now/gothic-neue/&openExternalBrowser=1" target="_blank" className="post-x">ポスト(X)</a>
      </div>
      <div style={{ fontSize: "80%" }}>
        <p>ヘルベチカ (初稿設定)</p>
        <p>14歳　144cmぐらい　肌は青白くやせ型、髪はあまり手入れされていない</p>
        <p>好き：読書、空想</p>
        <p>苦手：騒音、人を傷付けること</p>
        <p>誕生日：9月15日</p>
      </div>
      <div style={{ fontSize: "80%" }}>
        <p>Gothic:Neue by Bad Assort</p>
      </div>
    </section></>;

  switch (currentStep) {
    case 99:
      return helv;
    case 103:
      return dcay;
  }
  return norm;
}

export default Clear;
